import { Box, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExplotableItem, ExplotableList } from 'modules/core/components/GroupingExplotable'
import type { Access } from 'modules/core/store/models/Access'

import type { GroupProp } from 'modules/payroll_bundle/components/PayrollSummaryImport/PayrollSummaryImportModal/ImportSummaryWizard/_steps/reviewAndImportStep/EmployeeMatcher/_Table/types'
import { ImportData } from 'modules/payroll_bundle/lib/PayrollResultContext'

import GroupBody from './_GroupBody'

interface Props {
  groups: GroupProp[]
  selected?: Set<string>
  checkable?: boolean
  getUserFromImportData: (item: ImportData) => Access | null | undefined
  onSelectItem?: (supplement: ImportData) => void
  onAssignEmployee: (userId: string, index: string) => void
  onUnAssignEmployee: (userId: string, index: string) => void
  currency: string
}

type GroupProps = Pick<
  Props,
  | 'checkable'
  | 'selected'
  | 'getUserFromImportData'
  | 'onAssignEmployee'
  | 'onSelectItem'
  | 'onUnAssignEmployee'
  | 'currency'
> & { group: GroupProp }

const ExplotableGroup = ({
  checkable,
  selected,
  onAssignEmployee,
  onSelectItem,
  getUserFromImportData,
  group,
  onUnAssignEmployee,
  currency,
}: GroupProps) => {
  const [open, toggle] = useToggle(true)

  return (
    <ExplotableItem
      key={group.name}
      bottomRadius={false}
      dropDownAnimated={false}
      expandIcon="caret"
      headerBorders={false}
      headerRounded={false}
      opened={open}
      renderHeader={() => (
        <Box paddingLeft="s16">
          <Text.Normal size="200" weight="medium" color="grey800">
            {`${group.name} (${group.count})`}
          </Text.Normal>
        </Box>
      )}
      scrollLimited={false}
      size="small"
      toggle={toggle(!open)}
      type="primary"
    >
      <GroupBody
        selected={selected}
        checkable={checkable}
        onSelectItem={onSelectItem}
        getUserFromImportData={getUserFromImportData}
        resultItems={group.resultItems}
        onAssignEmployee={onAssignEmployee}
        onUnAssignEmployee={onUnAssignEmployee}
        currency={currency}
      />
    </ExplotableItem>
  )
}

const ResultGroups = ({
  groups,
  selected,
  checkable,
  getUserFromImportData,
  onSelectItem,
  onAssignEmployee,
  onUnAssignEmployee,
  currency,
}: Props) => {
  return (
    <ExplotableList>
      {groups.map((group) => {
        if (group.count > 0) {
          return (
            <ExplotableGroup
              key={group.name}
              group={group}
              selected={selected}
              checkable={checkable}
              getUserFromImportData={getUserFromImportData}
              onSelectItem={onSelectItem}
              onAssignEmployee={onAssignEmployee}
              onUnAssignEmployee={onUnAssignEmployee}
              currency={currency}
            />
          )
        }
      })}
    </ExplotableList>
  )
}

export default observer(ResultGroups)
